import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getMe } from '../profile/thunk';

interface LoginState {
  user: any;
  token: string;
  error: string;
  success: boolean;
}

const initialState: LoginState = {
  user: null,
  token: '',
  error: '',
  success: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginSuccess(state: LoginState, action: PayloadAction<string>) {
      state.success = true;
      state.token = action.payload;
    },
    logoutSuccess(state: LoginState) {
      state.success = false;
      state.token = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMe.fulfilled, (state: any, action: any) => {
      state.user = action.payload;
    });
  },
});

export const { loginSuccess, logoutSuccess } = loginSlice.actions;
export default loginSlice.reducer;
